import { getAgentRunUrl, useDocumentAgentRuns } from '~/entities/document-agent'
import { useAreFeatureFlagsReady, useIsFeatureEnabled } from '~/shared/lib/feature-flags'
import { Button, LocalIcon } from '~/shared/ui'
import { RUNS_STALE_TIME_MS } from '../config'

export function DocumentAgentLink({ documentKey }: { documentKey: string }) {
  const isFlagEnabled = useIsFeatureEnabled('2026-10-document-agent-viewer')
  // Before the first fetch the SDK answers from toggles cached by a previous session.
  const isEnabled = useAreFeatureFlagsReady() && isFlagEnabled
  const { data, isError } = useDocumentAgentRuns(documentKey, {
    enabled: isEnabled,
    staleTime: RUNS_STALE_TIME_MS,
  })

  if (!isEnabled || isError || !data?.runs.length) {
    return null
  }

  return (
    <Button to={getAgentRunUrl(documentKey)}>
      <span className="flex items-center gap-1.5">
        <LocalIcon name="optiBot" />
        <span>Agent run</span>
      </span>
    </Button>
  )
}
